import React from 'react'
import axios from 'axios'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import { Root } from './components/App/Root'
import './i18n'
import 'antd/dist/antd.css'
import './index.css'

axios.defaults.baseURL = 'https://site.caldetentazioni.com/api'
// axios.defaults.baseURL = 'http://localhost:7000'
axios.defaults.withCredentials = true

ReactDOM.render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
